import React from 'react';
import { MapPin, Phone, Fan as Fax, Globe2 } from 'lucide-react';

interface BranchData {
  name: string;
  phone: string;
  fax?: string;
  address: string;
  coordinates?: string;
  mobile?: string;
}

const branches: BranchData[] = [
  {
    name: "SALALAH (HQ)",
    phone: "+(968) 23211259 / 23212155",
    fax: "+(968) 23212644 / 23211240",
    address: "Hamdan Complex,Rabat Road",
    coordinates: "17.019481,54.061263"
  },
  {
    name: "SALALAH CITY",
    phone: "+(968) 23296903",
    fax: " +(968) 23296904",
    address: "Salaam Street Salalah",
    coordinates: "17.012988, 54.094153"
  },
  {
    name: "MUSCAT (RUWI)",
    phone: "+(968) 24832801 - 24832423",
    fax: " +(968) 24831681",
    address: " Al Hashar Complex, High Street, Ruwi",
    coordinates: "23.589268,58.545657"
  },
  {
    name: "Khaboura",
    phone: "+(968) 26801246",
    fax: "",
    address: "Main Round About",
    coordinates: ".."
  },
  {
    name: "Saham",
    phone: "+(968) 26855491",
    fax: "",
    address: "Behind Shell Petrol Pump",
    coordinates: ""
  },
  {
    name: "Samail",
    phone: "+(968) 25350334",
    fax: "",
    address: "Near Bank Muscat,Madrah",
    coordinates: ""
  },
  {
    name: "Buraimi",
    phone: "+(968) 25652688",
    fax: "+(968) 25652688",
    address: "Power House Road Nr Safeer Super Market",
    coordinates: "24.255353,55.769324"
  },
  {
    name: "Rustaq",
    phone: "+(968) 26878946",
    fax: "+(968) 26878946",
    address: " Murbal Gharbia Ainy-Kesfa",
    coordinates: "23.395203,57.425430"
  },
  {
    name: "Samail",
    phone: "+(968) 25350334",
    fax: "+(968) 25350334",
    address: "Madarah Samail",
    coordinates: "23.301743,57.955940"
  },
  {
    name: "Khaboura",
    phone: "+(968) 26801246",
    fax: "+(968) 26801246",
    address: "Near Round About Al Khaboura Batina Region",
    coordinates: "23.971575,57.091299"
  },
  {
    name: "Saham",
    phone: "+(968) 26855491",
    fax: "+(968) 26855491",
    address: "Near Shell Petrol Pump",
    coordinates: "24.143956,56.876451"
  },
  {
    name: "Khadra",
    phone: "+(968) 26712217",
    fax: " +(968) 26712210",
    address: "Opposite Bank MuscatAl Khadra North Willayat Al Swaiq",
    coordinates: "23.971575,57.091299"
  },
  {
    name: "Tharmad",
    phone: "+(968) 26810070",
    fax: " +(968) 26810115",
    address: "Near Discount Centre Al Tharmad Will Al Swaiq",
    coordinates: "23.78722,57.519992."
  },
  {
    name: "Al Kamil",
    phone: "+(968) 25558444",
    fax: "+(968) 25557343",
    address: "Near Bank Dhofar Al Kamil, Sharqiya Region",
    coordinates: ""
  },
  {
    name: "Liwa",
    phone: "+(968) 26762632",
    fax: "",
    address: "Near Liwa Round about, North Liwa",
    coordinates: ""
  }

];

const ExchangeBranch: React.FC<{ content?: any }> = ({ content }) => {
  const branchList = content?.branches?.length ? content.branches : branches;

  return (
    <section className="bg-white py-10">
      <div className="max-w-7xl mx-auto px-4 space-y-8">
        <div className="rounded-3xl border bg-gray-50 p-8 shadow-sm">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <div className="text-xs uppercase tracking-widest text-gray-500">
                Hamdan Exchange
              </div>
              <h2 className="mt-2 text-3xl font-bold text-gray-900">
                Our Branches
              </h2>
              <p className="mt-3 max-w-3xl text-sm text-gray-600 leading-relaxed">
                Branch contact details and locations across Oman.
              </p>
            </div>

            <div className="flex flex-wrap gap-2">
              <span className="text-xs px-3 py-1 rounded-full border bg-yellow-400">
                Salalah
              </span>
              <span className="text-xs px-3 py-1 rounded-full border bg-yellow-400">
                Muscat
              </span>
              <span className="text-xs px-3 py-1 rounded-full border bg-yellow-400">
                Oman
              </span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {branchList.map((branch: any, index: number) => (
            <div
              key={index}
              className="border border-yellow-300 rounded-2xl overflow-hidden shadow-lg shadow-gray-200/70 bg-[#fffaf0] h-full min-h-[250px] hover:shadow-xl transition-all duration-300"
            >
              <div className="bg-white px-5 py-4 flex items-center gap-3 min-h-[40px] border-b border-yellow-200">
                <div className="h-11 w-11 rounded-2xl bg-gradient-to-br from-orange-400 to-orange-700 text-white shadow-xl shadow-orange-200 flex items-center justify-center shrink-0">
                  <MapPin className="h-5 w-5" />
                </div>
                <h3 className="text-[16px] font-bold text-red-900">{branch.name}</h3>
              </div>

              <div className="px-8 py-7 space-y-3 text-sm bg-[#fffaf0]">
                <div className="flex items-center gap-2">
                  <Phone className="h-4 w-4 text-blue-600" />
                  <span className="text-gray-700 text-[12px] md:text-[14px]">Tel: {branch.phone}</span>
                </div>

                {branch.fax && (
                  <div className="flex items-center gap-2">
                    <Fax className="h-4 w-4 text-green-600" />
                    <span className="text-gray-700 text-[12px] md:text-[14px]">Fax: {branch.fax}</span>
                  </div>
                )}

                <div className="flex items-start gap-2">
                  <MapPin className="h-4 w-4 text-purple-600 mt-0.5" />
                  <span className="text-gray-700 text-[12px] md:text-[14px]">{branch.address}</span>
                </div>

                {branch.coordinates && (
                  <div className="flex items-start gap-2">
                    <Globe2 className="h-4 w-4 text-indigo-600 mt-0.5" />
                    <span className="text-gray-700 text-[12px] md:text-[14px]">
                      Coordinates: {branch.coordinates}
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExchangeBranch;
